// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Errors{margin-bottom:1em;color:#da1f3f}", ""]);
// Exports
module.exports = exports;
